/**
 * Title-case a display string.
 *
 * Deliberately a character-for-character mirror of `toTitleCase` in
 * jnana-native/src/components/visualFormatting/font.ts, which is what the app uses to
 * render collection names (both the browse grid and the detail hero). The two surfaces
 * show the same nodes, so they must capitalise them identically — if this ever diverges,
 * the same collection reads differently on web than in the app.
 *
 * Note it lowercases first, so an acronym like "SGS" renders as "Sgs". That is the app's
 * existing behaviour and parity is the point; change both sides together or neither.
 *
 * Diacritics are safe: `charAt(0).toUpperCase()` on ā/ō/ṛ leaves the combining mark
 * intact, so "prārthana" becomes "Prārthana" rather than being stripped.
 */
export function titleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
